import { render, staticRenderFns } from "./ThirteenTable.vue?vue&type=template&id=085b7eac&"
import script from "./ThirteenTable.vue?vue&type=script&lang=js&"
export * from "./ThirteenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports